export default "/images/snapchat-logo.png?9c80bef9a496a59f42aeb61127997871";